import { render, staticRenderFns } from "./lecture-category-form.vue?vue&type=template&id=5b4f8682"
import script from "./lecture-category-form.vue?vue&type=script&lang=js"
export * from "./lecture-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports